import { useWizard } from "react-use-wizard";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import useGeoPolygonByBuilding from "../../../../../../api/hooks/use-geo-polygon-by-building";
import tradeInSteps from "./tradeInSteps";
import BaseStep from "../../../../../shared/wizard/steps/baseStep";

interface ITradeInStep_4 {
  buildingId: number | null;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void;
}

const TradeInStep_4 = ({ buildingId, onChange, onReset }: ITradeInStep_4) => {
  const { goToStep } = useWizard();

  const { trigger } = useGeoPolygonByBuilding();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_3.step);
    onReset(["desiredLocationIds"]);
  };

  const handleYestStep = () => {
    goToStep(tradeInSteps.step_5.step);
    onReset(["desiredLocationIds"]);
  };

  const handleNotStep = async () => {
    if (buildingId) {
      // по текущему билдингу с оценки получаем полигон
      const data = await trigger(buildingId);
      onChange([data.id], "desiredLocationIds");
    }
    goToStep(tradeInSteps.step_6.step);
  };

  return (
    <div>
      <BaseStep
        counterPage={{
          current: tradeInSteps.step_4.page,
          max: tradeInSteps.step_4.maxPage,
        }}
        prevStep={handlePrevStep}
        yesStep={handleYestStep}
        noStep={handleNotStep}
        text={"Планируете сменить район проживания?"}
      />
    </div>
  );
};

export default TradeInStep_4;
